<template>
  <div>
    <address-header :clientInfo="clientInfo" />
    <simple-quarter-table :card="card"
                          fieldName="ContactsWithoutRating"
                          :headerText="$t('Webportal.CX.ContactsWithoutRating')" />
    <header-line :title="$t('Webportal.CX.MonthlyConsideration')" />
    <contacts-details-table :card="card" />
  </div>
</template>

<script>
import AddressHeader from '@/components/CX/DashboardCards/AddressHeader.vue';
import SimpleQuarterTable from '@/components/CX/DashboardCards/SimpleQuarterTable.vue';
import ContactsDetailsTable from '@/components/CX/DashboardCards/ContactsDetailsTable.vue';
import HeaderLine from '@/components/CX/DashboardCards/HeaderLine.vue';

export default {
  components: {
    AddressHeader, SimpleQuarterTable, ContactsDetailsTable, HeaderLine
  },

  props: {
    card:               { type: Object, default: undefined },
    clientInfo:         { type: Object, default: undefined },
    thresholds:         { type: Array, required: true }
  }
}
</script>